export default class LMSAPI
{
    send(params)
    {
        const rememberToken = localStorage.getItem("LMSToken");
        const sessionToken = sessionStorage.getItem("LMSToken");
        var authtoken  = rememberToken ? rememberToken : sessionToken ? sessionToken : null;
        if(!params.headers)
            params.headers = {};
        params.headers['Accept'] = 'application/json'
        if(!('Content-Type' in params.headers))
            params.headers['Content-Type'] = 'application/json'
        if (authtoken != null)
        {
            params.headers['Authorization'] = "Bearer " + authtoken;
        }
        if(('fileUpload' in params))
            delete params.headers["Content-Type"];
        if(params.debug) { console.log("Headers:"); console.dir( params.headers); }
        const url = "/api/" + params.controller + "/" + params.action
        if (params.debug)
        {
            console.log("API Request to " + url);
            console.log("Parameters: " + params.body);
        }
        fetch(url, {
            method: params.method,
            body: params.body,
            headers: params.headers,
        }).then(results => {
            if(!results.ok) { 
                console.dir(results.status);
                console.dir(results.body);
                throw Error(results); 
            }
            return results.json();
        }).then(data => {
            if (params.debug)
            {
                console.dir(data);
            }
            params.success(data);
        }).catch(function(error) {
            console.dir(error);
            params.error(error);
        })
    }

    download(params){
        const rememberToken = localStorage.getItem("LMSToken");
        const sessionToken = sessionStorage.getItem("LMSToken");
        var authtoken  = rememberToken ? rememberToken : sessionToken ? sessionToken : null;
        if(!params.headers)
            params.headers = {};
        if (authtoken != null)
        {
            params.headers['Authorization'] = "Bearer " + authtoken;
        }

        let download = require('downloadjs');
        const token = localStorage.getItem("ASToken");
        const url = "/api/" + params.controller + "/" + params.action
        fetch(url, {
            method: params.method,
            headers: params.headers,
        })
        .then(response => response.blob())
        .then(blob => download(blob, params.attachmentName))
    }
}


// WEBPACK FOOTER //
// ./src/general/api.js